import {
  Box,
  Breadcrumbs,
  Card,
  CircularProgress,
  FormLabel,
  Grid,
  Input,
  Stack,
  Typography,
} from '@mui/joy';
import { CreateEditWarehouseModal } from '@/components/Pages/Warehouses/CreateEditWarehouseModal';
import { createFileRoute, Link, Navigate } from '@tanstack/react-router';
import { pageTitle, usePageTitle } from '@/utils/pageTitle';
import { DeleteWarehouseModal } from '@/components/Pages/Warehouses/DeleteWarehouseModal';
import { useWarehouse } from '@/hooks/useWarehouses';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/warehouses/$id')({
  component: WarehouseDetail,
  head: () => pageTitle('Sucursales'),
});

function WarehouseDetail() {
  const { id } = Route.useParams();
  const { hasClaim, isLoading: authLoading } = useAuth();
  const canRead = hasClaim('WAREHOUSE_READ');
  const canWrite = hasClaim('WAREHOUSE_WRITE');

  const { data: warehouse, isLoading } = useWarehouse(id);
  usePageTitle('Sucursales', warehouse?.name);

  if (authLoading || isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!canRead) {
    return <Navigate to='/warehouses' />;
  }

  if (!warehouse) {
    return <div>Sucursal no encontrada</div>;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Stack direction='row' justifyContent='space-between'>
        <Breadcrumbs size='sm'>
          <Link to='/warehouses'>Sucursales</Link>
          <Typography>{warehouse?.name}</Typography>
        </Breadcrumbs>

        {canWrite && (
          <Stack direction='row' gap={1}>
            <CreateEditWarehouseModal warehouse={warehouse} />
            <DeleteWarehouseModal
              id={warehouse?.id.toString()}
              name={warehouse?.name}
            />
          </Stack>
        )}
      </Stack>

      <Card>
        <Grid container spacing={{ xs: 1, sm: 2 }}>
          <Grid xs={12} md={6}>
            <FormLabel>Nombre</FormLabel>
            <Input
              value={warehouse?.name}
              readOnly
              variant='soft'
              size='sm'
              sx={{ backgroundColor: 'background.body' }}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <FormLabel>Dirección</FormLabel>
            <Input
              value={warehouse?.address}
              readOnly
              variant='soft'
              size='sm'
              sx={{ backgroundColor: 'background.body' }}
            />
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
}
